import React from "react";
import {
  ReferenceField,
  TabbedForm,
  FormTab,
  EditController,
  EditView,
  SelectInput,
  BooleanInput,
  SaveButton,
  Toolbar,
  TextField,
  TextInput
} from "react-admin";
import FootballFormTab from "./FootballFormTab";
import GirlsVolleyballFormTab from "./GirlsVolleyballFormTab";
import BasketballFormTab from "./BasketballFormTab";
import SoccerFormTab from "./SoccerFormTab";
import BaseballFormTab from "./BaseballFormTab";
import DeleteIcon from "@material-ui/icons/Delete";
import PlayerDeleteDialog from "./PlayerDeleteDialog";
import { useDataProvider } from "react-admin";
import { useEditController } from "react-admin";
import { useNotify, useRedirect, useRefresh } from "react-admin";
import { useState } from "react";
import WarningButton from "components/WarningButton";

const PlayerEdit = (props) => {
  const { record } = useEditController(props);
  const notify = useNotify();
  const redirect = useRedirect();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const [playerGames, setPlayerGames] = useState(false);
  const dataProvider = useDataProvider();

  async function deleteAction() {
    const playerGames = await dataProvider.getManyReference("gamePlayers", {
      target: "school_sport_season_team_id",
      id: record.id
    });
    setPlayerGames(playerGames.data);
    setOpen(true);
  }

  async function handleDeleteConfirm() {
    // eslint-disable-next-line no-unused-vars
    const deleteResponse = await dataProvider.delete("players", {
      id: record.id
    });
    setOpen(false);
    notify("Player Deleted");
    redirect(`/seasonTeams/${record.team.id}/show/9`);
    refresh();
  }

  async function handleDeleteCancel() {
    setOpen(false);
  }

  const CustomToolbar = function(props) {
    const redirectPath = `/players/${props.record.id}/show`;
    return (
      <Toolbar {...props}>
        <SaveButton redirect={redirectPath} />
        <WarningButton label="Delete" onClick={deleteAction}>
          <DeleteIcon />
        </WarningButton>
      </Toolbar>
    );
  };

  return (
    <React.Fragment>
      <EditController undoable={false} {...props}>
        {(controllerProps) => (
          <EditView undoable={false} {...props} {...controllerProps}>
            <TabbedForm toolbar={<CustomToolbar />}>
              <FormTab label="summary">
                <TextField source="id" />
                <ReferenceField
                  label="Name"
                  source="person.id"
                  reference="people"
                >
                  <TextField source="name" />
                </ReferenceField>
                <TextInput source="jerseyNumber" />
                <TextInput source="position" />
                <TextInput source="additionalPositions" />
                <SelectInput
                  source="yearCode"
                  allowEmpty="true"
                  choices={[
                    { id: "FRESHMAN", name: "FRESHMAN" },
                    { id: "SOPHOMORE", name: "SOPHOMORE" },
                    { id: "JUNIOR", name: "JUNIOR" },
                    { id: "SENIOR", name: "SENIOR" }
                  ]}
                />
                <BooleanInput source="isActive" />
              </FormTab>
              {controllerProps.record &&
                controllerProps.record.sportCode === "football" && (
                  <FormTab label="football">
                    <FootballFormTab />
                  </FormTab>
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "girls-volleyball" && (
                  <FormTab label="volleyball">
                    <GirlsVolleyballFormTab />
                  </FormTab>
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "girls-basketball" && (
                  <FormTab label="girls-basketball">
                    <BasketballFormTab />
                  </FormTab>
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "boys-basketball" && (
                  <FormTab label="boys-basketball">
                    <BasketballFormTab />
                  </FormTab>
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "girls-soccer" && (
                  <FormTab label="girls-soccer">
                    <SoccerFormTab />
                  </FormTab>
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "boys-soccer" && (
                  <FormTab label="boys-soccer">
                    <SoccerFormTab />
                  </FormTab>
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "softball" && (
                  <FormTab label="softball">
                    <BaseballFormTab />
                  </FormTab>
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "baseball" && (
                  <FormTab label="baseball">
                    <BaseballFormTab />
                  </FormTab>
                )}
            </TabbedForm>
          </EditView>
        )}
      </EditController>
      <PlayerDeleteDialog
        open={open}
        playerGames={playerGames}
        handleCancel={handleDeleteCancel}
        handleDelete={handleDeleteConfirm}
      />
    </React.Fragment>
  );
};

export default PlayerEdit;
